import React, { Component } from 'react'

import { IField } from '@features/forms'

interface IProps {
  label?: string
  id?: string
  field: IField
  info?: string
  /** Warning message (eg. for email spelling correction) */
  warning?: any
  optional?: boolean
  icon?: JSX.Element | null
}

/**
 * Default markup for Calculator fields
 */
export default class FieldContainer extends Component<IProps> {
  render() {
    const { label, id, field, optional, info, warning, icon } = this.props
    const error = field && field.touched && field.error
    let fieldIcon
    let fieldClassName = 'Field'
    let fieldError

    // Required
    if (!optional) {
      fieldClassName += ' -is-required'
    }

    // className for field container
    if (field && field.focussed) {
      fieldClassName += ' focussed'
    }
    if (field && String(field.value || '').trim().length > 0) {
      fieldClassName += ' has-value'
    }

    // Field icon
    if (icon) {
      fieldIcon = <span className="Icon">{icon}</span>
    }

    if (error) {
      fieldClassName += ' -has-errors'
      fieldError = (
        <ul className={'FieldErrors'}>
          <li>{error}</li>
        </ul>
      )
    } else if (warning) {
      fieldClassName += ' -has-warnings'
      fieldError = (
        <ul className={'FieldWarnings'}>
          <li>{warning}</li>
        </ul>
      )
    }

    return (
      <div className={fieldClassName}>
        {label && (
          <label className={'Label'} htmlFor={id || (field && field.name)}>
            {label}
          </label>
        )}

        {info ? <p className="Text -small -light -mod-wrap-wide">{info}</p> : null}

        <div className={'Control' + (icon ? ' -has-icon-left' : '')}>
          {this.props.children}
          {fieldIcon}
          {fieldError}
        </div>
      </div>
    )
  }
}
